var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"reaction",style:([
      this.selected == true
        ? { 'background-color': 'black', color: 'white' }
        : {} ])},[_vm._v(" "+_vm._s(_vm.newReaction)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }